import { FormEvent, useState } from "react";
import { legacyConsultRows } from "../../mock/legacyConsultList";
import "./LegacyConsultList.css";
const heads = [
  "No",
  "지점",
  "상담일",
  "상담자",
  "고객번호",
  "(old)",
  "아기",
  "엄마",
  "휴대폰",
  "계약구분",
  "상담내용",
  "성사된 계약",
  "총액 합",
  "선금 합",
  "중도금 합",
  "잔금 합",
  "상담 촬영스케줄",
];
const widths = [
  59.96875, 94.703125, 123.8125, 123.8125, 152.875, 111.671875, 94.703125,
  94.703125, 123.8125, 152.875, 152.875, 189.75, 131.5625, 131.5625, 160.640625,
  131.5625, 248.109375,
];
export function LegacyConsultList() {
  const [office, setOffice] = useState("Mock 지점 01"),
    [from, setFrom] = useState("2026-08-20"),
    [to, setTo] = useState("2026-08-20"),
    [staff, setStaff] = useState("전체"),
    [contract, setContract] = useState("전체"),
    [searched, setSearched] = useState(false),
    [expand, setExpand] = useState(false),
    [notice, setNotice] = useState<string | null>(null);
  const setPeriod = (type: string) => {
    if (type === "today") {
      setFrom("2026-08-20");
      setTo("2026-08-20");
    } else if (type === "this") {
      setFrom("2026-08-01");
      setTo("2026-08-20");
    } else if (type === "last") {
      setFrom("2026-07-01");
      setTo("2026-07-31");
    } else {
      setFrom("2026-05-01");
      setTo("2026-08-20");
    }
  };
  const submit = (e: FormEvent) => {
    e.preventDefault();
    if (from > to) {
      setNotice("Mock 시작일자는 종료일자보다 클 수 없습니다.");
      return;
    }
    const p = new URLSearchParams({
      office_id:
        office === "Mock 지점 01" ? "mock-office-01" : "mock-office-02",
      consult_dt_1: from,
      consult_dt_2: to,
      consult_staff_id: staff === "전체" ? "" : staff,
      contract_type: contract === "전체" ? "" : contract,
      is_search: "1",
    });
    window.history.replaceState({}, "", `${location.pathname}?${p}`);
    setSearched(true);
    setNotice(
      "Mock 고객 상담 목록을 검색했습니다. 실제 API에는 연결하지 않았습니다.",
    );
  };
  const customer = () =>
    window.open(
      "/v1/customer/?CRUD=2&id=mock-consult-customer-01&caller=customer_consult_manage",
      "_blank",
      "popup=yes,width=1080,height=1000",
    );
  const consult = () => setNotice("Mock 상담 상세 팝업 처리되었습니다.");
  const schedule = () => setNotice("Mock 촬영스케줄 팝업 처리되었습니다.");
  return (
    <div className="legacy-a02">
      <section className="g_filter_wrap">
        <form id="l_form_search" onSubmit={submit}>
          <div className="g_row">
            <div className="g_input_wrap required">
              <label className="g_label title center">지점</label>
              <select
                id="l_inp_office"
                className="g_input width_2x"
                value={office}
                onChange={(e) => setOffice(e.target.value)}
              >
                <option>Mock 지점 01</option>
                <option>Mock 지점 02</option>
              </select>
            </div>
          </div>
          <div className="g_row">
            <div className="g_input_wrap required">
              <label className="g_label title center">상담기간</label>
              <input
                id="l_inp_consult_dt_1"
                className="g_input g_input_datepicker"
                value={from}
                onChange={(e) => setFrom(e.target.value)}
              />
              <span>~</span>
              <input
                id="l_inp_consult_dt_2"
                className="g_input g_input_datepicker"
                value={to}
                onChange={(e) => setTo(e.target.value)}
              />
              {[
                ["today", "오늘"],
                ["this", "이번달"],
                ["last", "지난달"],
                ["three", "최근 3개월"],
              ].map(([id, label]) => (
                <button
                  type="button"
                  className="g2_btn size_2 l_btn_consult_period_set"
                  key={id}
                  onClick={() => setPeriod(id)}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>
          <div className="g_row">
            <div className="g_input_wrap">
              <label className="g_label title center">상담자</label>
              <select
                id="l_inp_consult_staff"
                className="g_input width_2x"
                value={staff}
                onChange={(e) => setStaff(e.target.value)}
              >
                <option>전체</option>
                <option>Mock 상담자 01</option>
              </select>
            </div>
          </div>
          <div className="g_row">
            <div className="g_input_wrap">
              <label className="g_label title center">계약구분</label>
              <select
                id="l_inp_contract_type"
                className="g_input width_2x"
                value={contract}
                onChange={(e) => setContract(e.target.value)}
              >
                <option>전체</option>
                <option>Mock 계약구분 A</option>
              </select>
            </div>
          </div>
          <br />
          <div className="g_row">
            <div className="g_input_wrap">
              <label className="g_label no_style" />
              <button className="g2_btn g_btn_submit search" type="submit">
                검색
              </button>
            </div>
          </div>
        </form>
      </section>
      <section className={`g_filter_value_wrap ${searched ? "" : "g_hidden"}`}>
        지점 <b>{office}</b>　기간{" "}
        <b>
          {from} ~ {to}
        </b>
        　상담자 <b>{staff}</b>　계약구분 <b>{contract}</b>
      </section>
      <section className="g_card g_result_table_wrap">
        <div className="g_row">
          <div className="g2_page_count_wrap">
            {searched
              ? `Data : 1 to ${legacyConsultRows.length} (total : ${legacyConsultRows.length})`
              : ""}
          </div>
          <label className="g_input checkbox_wrap">
            <input
              id="l_chk_expand_content"
              className="g_input checkbox"
              type="checkbox"
              checked={expand}
              onChange={(e) => setExpand(e.target.checked)}
            />
            내용 펼치기
          </label>
          {searched && (
            <button
              className="g_btn download"
              type="button"
              onClick={() => setNotice("Mock 엑셀 다운로드 처리되었습니다.")}
            >
              엑셀 다운로드
            </button>
          )}
        </div>
        <div className="g_list_wrap">
          <table className="g_list" id="l_search_result_table">
            <colgroup>
              {widths.map((w, i) => (
                <col key={i} style={{ width: w }} />
              ))}
            </colgroup>
            <thead>
              <tr>
                {heads.map((x) => (
                  <th key={x}>{x}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {searched ? (
                legacyConsultRows.map((r, i) => (
                  <tr key={r.id}>
                    <td>{i + 1}</td>
                    <td>{r.office}</td>
                    <td>{r.date}</td>
                    <td>{r.staff}</td>
                    <td>
                      <button onClick={customer} className="g_item">
                        {r.customer}
                      </button>
                    </td>
                    <td>
                      <button onClick={customer} className="g_item">
                        {r.old}
                      </button>
                    </td>
                    <td>
                      <button onClick={customer} className="g_item">
                        {r.baby}
                      </button>
                    </td>
                    <td>
                      <button onClick={customer} className="g_item">
                        {r.parent}
                      </button>
                    </td>
                    <td>
                      <button onClick={customer} className="g_item">
                        {r.phone}
                      </button>
                    </td>
                    <td>
                      <button onClick={consult} className="g_item">
                        {r.contract}
                      </button>
                    </td>
                    <td
                      className={`l_consult_contents ${expand ? "expanded" : ""}`}
                    >
                      <button onClick={consult} className="g_item">
                        {r.content}
                      </button>
                    </td>
                    <td className="left">{r.contracted}</td>
                    <td className="right">{r.total}</td>
                    <td className="right">{r.advance}</td>
                    <td className="right">{r.interim}</td>
                    <td className="right">{r.balance}</td>
                    <td>
                      <button onClick={schedule} className="g_item">
                        {r.schedule}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>데이타를 검색 하세요...</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {searched && (
          <div className="g2_pagination_wrap">
            <button type="button">1</button>
          </div>
        )}
      </section>
      {notice && (
        <div className="a02-notice">
          {notice}
          <button type="button" onClick={() => setNotice(null)}>
            ×
          </button>
        </div>
      )}
    </div>
  );
}
